module.exports = __webpack_public_path__ + "img/dc1000.62f6c6cb.jpg";